import { useTypeSelectors } from "hooks/useTypeSelectors";
import { FC } from "react";
import { DateLabelType, FalconDateData } from "types/Falcon";
import { useStyles } from "./styles";
import { Box, TableCell, Typography } from "@material-ui/core";
import moment from "moment";
import { CustomDrawer } from "componentsNew/drawers/CustomDrawer";
import CustomIconButton from "componentsNew/buttons/CustomIconButton";
import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedInOutlined";
import { FalconDrawerContent } from "../../componentsNew/drawers/drawerContent/FalconDrawerContent";
import { DateTime } from "luxon";

interface PropsType {
  columnData: DateLabelType;
}

export const FalconTableHeadCell: FC<PropsType> = ({ columnData }) => {
  const classes = useStyles();
  const { falconFilters, falconData } = useTypeSelectors((state) => state.falconTable);

  const commentItem = falconData?.commentList?.find(
    (commentItem) => columnData.date === commentItem?.report_date,
  );

  const commentDate = DateTime.fromISO(String(columnData.date) || "")

  return (
    <TableCell className={`${classes.tableHeadCell}`} colSpan={2}>
      <Box
        className={`${classes.tableCellContent} ${classes.borderCellRightLight} ${classes.labelBox}`}
      >
        <Box>
          <Typography className={classes.label}>
            {falconFilters.selectType === "week" && String(columnData?.label)?.slice(0, 3)}
          </Typography>
          <Typography className={classes.mainLabel}>
            {falconFilters.selectType === "week"
              ? getCheckDayDate(falconData?.dateList, String(columnData.label))
              : `Week ${columnData.date}`}
          </Typography>
        </Box>
        {falconFilters.selectType === "week" && falconFilters.station !== "0" ? (
          <CustomDrawer
            customWidth={700}
            buttonType={"custom"}
            drawer_name={`falcon-comment-${columnData.date}`}
            drawerTitle={`Verify Information for ${commentDate.toFormat("dd-MM-yyyy")} (${commentDate.toFormat("cccc")})`}
            customButtonElement={
              <CustomIconButton
                icon={<AssignmentTurnedIn />}
                iconColor={
                  commentItem?.is_match && commentItem?.is_match > 0 ? "white" : "darkGray"
                }
                theme={
                  commentItem?.is_match === 1
                    ? "green"
                    : commentItem?.is_match === 2
                      ? "red"
                      : "gray"
                }
              />
            }
          >
            <FalconDrawerContent date={columnData.date} data={commentItem} />
          </CustomDrawer>
        ): ""}
      </Box>
    </TableCell>
  );
};

const getCheckDayDate = (currentData: FalconDateData[] | null, dayName: string) => {
  const dt = currentData?.find((item: FalconDateData) => item?.day === dayName)?.date;
  if (dt) {
    return moment(dt).utc(true).format("DD.MM");
  }
};
